import { render, staticRenderFns } from "./siip_setup.vue?vue&type=template&id=2a280d96&"
import script from "./siip_setup.vue?vue&type=script&lang=js&"
export * from "./siip_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports